<aside class="flex h-full flex-col border-r border-slate-200 bg-white transition-[width] duration-200 ease-in-out" [ngClass]="widthClass()">
  <nav class="flex flex-1 flex-col gap-1 overflow-y-auto p-2" aria-label="Main">
    @for (item of items(); track item.id) {
      <a
        [routerLink]="item.route"
        routerLinkActive="bg-blue-50 text-blue-700"
        class="group flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 hover:text-slate-900"
        [pTooltip]="item.label"
        [tooltipDisabled]="!collapsed()"
        tooltipPosition="right"
      >
        <i [class]="item.icon + ' text-base'" aria-hidden="true"></i>
        @if (!collapsed()) {
          <span class="truncate">{{ item.label }}</span>
        }
      </a>
    } @empty {
      @if (!collapsed()) {
        <div class="px-3 py-2 text-xs italic text-slate-400">No modules available</div>
      }
    }
  </nav>

  <div class="border-t border-slate-200 p-3 text-xs text-slate-400">
    @if (!collapsed()) {
      <span>v0.0.0 &middot; Phase 6.1</span>
    } @else {
      <span class="block text-center">v0</span>
    }
  </div>
</aside>
